import { documentService } from "@features/document/DocumentService";
import { DocumentOutputDTO } from '@features/document/types';
import createEntitySlice from "@services/createEntitySlice";

const {
  reducer: DocumentReducer,
  actions: DocumentActions,
  fetchAll: fetchDocuments,
  fetchById: fetchDocumentById,
  createEntity: createDocument,
  updateEntity: updateDocument,
  deleteEntity: deleteDocument,
} = createEntitySlice<DocumentOutputDTO>("Document", documentService);

export {
  DocumentReducer,
  DocumentActions,
  fetchDocuments,
  fetchDocumentById,
  createDocument,
  updateDocument,
  deleteDocument,
}; 